export default function SiteFooter() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-white/5 bg-black"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
                <div className="flex items-center gap-2.5">
                    <span
                        aria-hidden="true"
                        className="flex h-7 w-7 items-center justify-center rounded-lg border border-[#10B981]/30 bg-[#10B981]/10 text-[12px] font-semibold text-[#34D399]"
                    >
                        D
                    </span>
                    <span className="font-display text-[15px] font-semibold">
                        Dendros<span className="text-[#10B981]">.ai</span>
                    </span>
                    <span className="ml-3 text-[11px] text-neutral-600 font-mono tracking-wider uppercase">
                        Revenue Integrity Platform
                    </span>
                </div>

                <div className="flex items-center gap-6 text-[12px] text-neutral-500">
                    <a
                        href="#problem"
                        className="hover:text-white transition-colors"
                    >
                        Problem
                    </a>
                    <a
                        href="#solution"
                        className="hover:text-white transition-colors"
                    >
                        Platform
                    </a>
                    <a
                        href="#trust"
                        className="hover:text-white transition-colors"
                    >
                        Security
                    </a>
                    <a
                        href="mailto:hello@dendros.ai"
                        className="hover:text-white transition-colors"
                    >
                        Contact
                    </a>
                </div>

                <div className="text-[11px] text-neutral-600 font-mono">
                    © {new Date().getFullYear()} Dendros AI · All rights
                    reserved
                </div>
            </div>
        </footer>
    );
}
